/**
 * Categoria do alarme, como a tabela de alarmes a registra.
 *
 * `NETWORK_ALARM` nunca entra no Mapa de Atenção dos Ativos: comunicação não é
 * assunto daquela tela, e sim do Painel de Status de Comunicação. Ver
 * docs/adr/0013-mapa-de-atencao-sem-comunicacao.md
 */
export const alarmCategories = {
  ALARM: 'alarm',
  NETWORK_ALARM: 'network-alarm',
  SELF_DIAGNOSIS: 'self-diagnosis',
};

/**
 * Classificações de alarme, vindas da Configuração de Alarme. Sem configuração,
 * ou com ela indefinida, o backend manda `Ordinario`.
 */
export const alarmClassifications = {
  CRITICAL: 'critical',
  URGENT: 'urgent',
  ORDINARY: 'ordinary',
};

export default alarmCategories;
